/* ==========================================================================
   LUX — Product page (Touro-style)

   Variant matching, the 2-up gallery carousel, click-to-zoom, accordions,
   the size guide modal and share. Everything uses data-lux-pdp-* attributes
   scoped to [data-lux-pdp], so nothing here collides with the global
   delegated listeners in lux-cart.js (add to cart, quantity stepper) or
   lux-wishlist.js.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Money — mirrors Shopify's formatMoney so INR "Rs. 1,299.00" and every
     other shop format round-trip correctly instead of being rebuilt from a
     guessed currency prefix.
     --------------------------------------------------------------------- */

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'number' ? precision : 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    var match = fmt.match(placeholder);
    if (!match) return fmt;

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return fmt.replace(placeholder, value);
  }

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ---------------------------------------------------------------------
     Variant matching
     --------------------------------------------------------------------- */

  function selectedOptions(root) {
    var values = [];
    root.querySelectorAll('[data-lux-pdp-option-group]').forEach(function (group) {
      var active = group.querySelector('[data-lux-pdp-option-value][aria-pressed="true"]');
      values.push(active ? active.getAttribute('data-value') : null);
    });
    return values;
  }

  function matchVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (chosen[j] === null) continue;
        if (v.options[j] !== chosen[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  function updateVariant(root, skipPrice) {
    var variants = readJSON(root, '[data-lux-pdp-variants]') || [];
    var chosen = selectedOptions(root);
    var variant = matchVariant(variants, chosen);
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    var idInput = root.querySelector('[data-lux-pdp-variant-id]');
    var submit = root.querySelector('[data-lux-pdp-submit]');
    var label = submit ? submit.querySelector('[data-label]') : null;
    var addLabel = (label && label.getAttribute('data-add-label')) || 'Add to Cart';
    var stockRoot = root.querySelector('[data-lux-pdp-stock]');

    // Mark which values still lead to an in-stock variant.
    root.querySelectorAll('[data-lux-pdp-option-group]').forEach(function (group, gi) {
      var selectedLabel = group.querySelector('[data-lux-pdp-option-selected]');
      var active = group.querySelector('[data-lux-pdp-option-value][aria-pressed="true"]');
      if (selectedLabel && active) selectedLabel.textContent = active.getAttribute('data-value');

      group.querySelectorAll('[data-lux-pdp-option-value]').forEach(function (btn) {
        var probe = chosen.slice();
        probe[gi] = btn.getAttribute('data-value');
        var candidate = matchVariant(variants, probe);
        btn.setAttribute('data-available', candidate && candidate.available ? 'true' : 'false');
      });
    });

    if (!variant) {
      if (submit) submit.disabled = true;
      if (label) label.textContent = 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (submit) submit.disabled = !variant.available;
    if (label) label.textContent = variant.available ? addLabel : 'Sold out';

    /* ---- Price ----
       Skipped on the very first pass so the server-rendered price (already
       correct, and formatted by Liquid) is never briefly rewritten. */
    if (!skipPrice) {
      var current = root.querySelector('[data-lux-price]');
      var compare = root.querySelector('[data-lux-compare-price]');
      var discount = root.querySelector('[data-lux-discount]');

      // money_format is shop configuration and may legitimately contain
      // markup, so it is written as HTML rather than text.
      if (current) current.innerHTML = formatMoney(variant.price, moneyFormat);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (compare) {
        if (onSale) {
          compare.innerHTML = formatMoney(variant.compare_at_price, moneyFormat);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      if (discount) {
        if (onSale) {
          var saved = Math.round(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          );
          discount.textContent = '−' + saved + '%';
          discount.hidden = false;
        } else {
          discount.hidden = true;
        }
      }
    }

    /* ---- Stock line ---- */
    if (stockRoot && !skipPrice) {
      var threshold = parseInt(stockRoot.getAttribute('data-low-threshold'), 10) || 5;
      if (!variant.available) {
        stockRoot.innerHTML =
          '<span class="tp-stock tp-stock--out"><span class="tp-stock__dot"></span>Sold out</span>';
      } else if (
        variant.inventory_management &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= threshold
      ) {
        stockRoot.innerHTML =
          '<span class="tp-stock tp-stock--low"><span class="tp-stock__dot"></span>Only ' +
          variant.inventory_quantity +
          ' left</span>';
      } else {
        stockRoot.innerHTML =
          '<span class="tp-stock"><span class="tp-stock__dot"></span>In stock</span>';
      }
    }

    // Keep the URL shareable without a full navigation.
    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {
        /* no-op */
      }
    }

    if (variant.featured_image && variant.featured_image.id) {
      scrollGalleryToMedia(root, variant.featured_image.id);
    }
  }

  /* ---------------------------------------------------------------------
     Gallery
     --------------------------------------------------------------------- */

  function galleryState(root) {
    var scroller = root.querySelector('[data-lux-pdp-scroller]');
    if (!scroller) return null;
    return {
      scroller: scroller,
      slides: Array.prototype.slice.call(scroller.querySelectorAll('[data-lux-pdp-slide]')),
      counter: root.querySelector('[data-lux-pdp-counter]'),
      prev: root.querySelector('[data-lux-pdp-prev]'),
      next: root.querySelector('[data-lux-pdp-next]')
    };
  }

  function scrollGalleryToMedia(root, mediaId) {
    var state = galleryState(root);
    if (!state) return;

    var target = state.slides.filter(function (slide) {
      return slide.getAttribute('data-media-id') === String(mediaId);
    })[0];

    if (!target) return;

    // scrollIntoView would also scroll the page vertically on a sticky
    // layout; moving the scroller itself keeps the viewport still.
    state.scroller.scrollTo({ left: target.offsetLeft - state.scroller.offsetLeft, behavior: 'smooth' });
  }

  function initGallery(root) {
    var state = galleryState(root);
    if (!state || state.slides.length < 2) return;

    function step() {
      return state.slides[0].getBoundingClientRect().width + 8; // slide + gap
    }

    if (state.prev) {
      state.prev.addEventListener('click', function () {
        state.scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (state.next) {
      state.next.addEventListener('click', function () {
        state.scroller.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    // Counter + arrow enable/disable, driven by scroll position so it stays
    // correct whether the shopper used the arrows, a swipe or a trackpad.
    function sync() {
      var left = state.scroller.scrollLeft;
      var max = state.scroller.scrollWidth - state.scroller.clientWidth;
      var index = Math.min(state.slides.length - 1, Math.round(left / step()));

      if (state.counter) {
        state.counter.textContent = index + 1 + ' / ' + state.slides.length;
      }
      if (state.prev) state.prev.style.opacity = left <= 2 ? '0.35' : '1';
      if (state.next) state.next.style.opacity = left >= max - 2 ? '0.35' : '1';
    }

    var ticking = false;
    state.scroller.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------------------------------------------------------------------
     Modal plumbing shared by the size guide and the zoom viewer
     --------------------------------------------------------------------- */

  // Close is deferred so the fade can finish; reopening within that window
  // must cancel the pending hide, or it would blank a modal the shopper
  // just reopened.
  var pendingHide = new WeakMap();

  function openModal(modal) {
    if (!modal) return;

    var pending = pendingHide.get(modal);
    if (pending) {
      window.clearTimeout(pending);
      pendingHide.delete(modal);
    }

    modal.setAttribute('aria-hidden', 'false');

    // Two rAFs guarantee the closed state has painted before .is-open is
    // added, so the transition animates instead of snapping. rAF is frozen
    // in background tabs, so a timeout backstops it — otherwise the modal
    // could sit at opacity 0 while still blocking the page.
    var reveal = function () {
      modal.classList.add('is-open');
    };

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(reveal);
    });
    window.setTimeout(reveal, 60);

    if (window.LuxUI && window.LuxUI.lockScroll) window.LuxUI.lockScroll();
    else document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

    modal.classList.remove('is-open');

    // Let the fade finish before it is display:none'd.
    pendingHide.set(
      modal,
      window.setTimeout(function () {
        modal.setAttribute('aria-hidden', 'true');
        pendingHide.delete(modal);
      }, 280)
    );

    if (window.LuxUI && window.LuxUI.unlockScroll) window.LuxUI.unlockScroll();
    else document.documentElement.style.overflow = '';
  }

  function anyModalOpen(root) {
    return root.querySelector('.tp-modal[aria-hidden="false"]');
  }

  /* ---------------------------------------------------------------------
     Size guide
     --------------------------------------------------------------------- */

  function initSizeGuide(root) {
    var modal = root.querySelector('[data-lux-size-guide-modal]');
    if (!modal) return;

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lux-size-guide-open]')) {
        e.preventDefault();
        openModal(modal);
        return;
      }
      if (e.target.closest('[data-lux-size-guide-close]')) {
        e.preventDefault();
        closeModal(modal);
      }
    });
  }

  /* ---------------------------------------------------------------------
     Zoom viewer — built from the gallery, so there is one source of truth
     for the image list.
     --------------------------------------------------------------------- */

  function initZoom(root) {
    var modal = root.querySelector('[data-lux-zoom-modal]');
    if (!modal) return;

    var stageImg = modal.querySelector('[data-lux-zoom-image]');
    var counter = modal.querySelector('[data-lux-zoom-counter]');
    var stage = modal.querySelector('[data-lux-zoom-stage]');

    var sources = Array.prototype.slice
      .call(root.querySelectorAll('[data-lux-pdp-slide] img'))
      .map(function (img) {
        return {
          src: img.getAttribute('data-zoom-src') || img.currentSrc || img.src,
          alt: img.getAttribute('alt') || ''
        };
      });

    if (!sources.length) return;

    var index = 0;

    function show(i) {
      index = (i + sources.length) % sources.length;
      stageImg.src = sources[index].src;
      stageImg.alt = sources[index].alt;
      if (counter) counter.textContent = index + 1 + ' / ' + sources.length;
      if (stage) stage.scrollTop = 0;
    }

    root.addEventListener('click', function (e) {
      var slide = e.target.closest('[data-lux-pdp-slide]');
      if (slide && root.contains(slide) && !e.target.closest('.tp-modal')) {
        // Only images zoom — a video slide keeps its own controls.
        if (!slide.querySelector('img')) return;
        e.preventDefault();
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lux-pdp-slide]'));
        show(slides.indexOf(slide));
        openModal(modal);
      }
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-lux-zoom-close]')) {
        e.preventDefault();
        closeModal(modal);
      } else if (e.target.closest('[data-lux-zoom-prev]')) {
        e.preventDefault();
        show(index - 1);
      } else if (e.target.closest('[data-lux-zoom-next]')) {
        e.preventDefault();
        show(index + 1);
      }
    });

    root.addEventListener('lux:zoom-key', function (e) {
      if (e.detail === 'ArrowLeft') show(index - 1);
      if (e.detail === 'ArrowRight') show(index + 1);
    });
  }

  /* ---------------------------------------------------------------------
     Accordion
     --------------------------------------------------------------------- */

  function initAccordion(root) {
    root.querySelectorAll('[data-lux-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.tp-accordion__item');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------------
     Share
     --------------------------------------------------------------------- */

  function initShare(root) {
    var btn = root.querySelector('[data-lux-share-copy]');
    if (!btn) return;

    var flag = root.querySelector('[data-lux-share-copied]');

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-share-url') || window.location.href;

      var done = function () {
        if (!flag) return;
        flag.classList.add('is-visible');
        window.setTimeout(function () {
          flag.classList.remove('is-visible');
        }, 1600);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(done);
      } else {
        var tmp = document.createElement('input');
        tmp.value = url;
        document.body.appendChild(tmp);
        tmp.select();
        try {
          document.execCommand('copy');
        } catch (e) {
          /* no-op */
        }
        document.body.removeChild(tmp);
        done();
      }
    });
  }

  /* ---------------------------------------------------------------------
     Options
     --------------------------------------------------------------------- */

  function initOptions(root) {
    root.addEventListener('click', function (e) {
      var optionBtn = e.target.closest('[data-lux-pdp-option-value]');
      if (!optionBtn) return;

      e.preventDefault();

      var group = optionBtn.closest('[data-lux-pdp-option-group]');
      if (!group) return;

      group.querySelectorAll('[data-lux-pdp-option-value]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === optionBtn ? 'true' : 'false');
      });

      updateVariant(root);
    });
  }

  /* ---------------------------------------------------------------------
     Keyboard — Escape closes whichever modal is open, arrows page the
     zoom viewer.
     --------------------------------------------------------------------- */

  function initKeyboard(root) {
    document.addEventListener('keydown', function (e) {
      var open = anyModalOpen(root);
      if (!open) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal(open);
      } else if (
        (e.key === 'ArrowLeft' || e.key === 'ArrowRight') &&
        open.hasAttribute('data-lux-zoom-modal')
      ) {
        e.preventDefault();
        root.dispatchEvent(new CustomEvent('lux:zoom-key', { detail: e.key }));
      }
    });
  }

  /* ---------------------------------------------------------------------
     Init
     --------------------------------------------------------------------- */

  function init(scope) {
    (scope || document).querySelectorAll('[data-lux-pdp]').forEach(function (root) {
      if (root.dataset.luxPdpInit === 'true') return;
      root.dataset.luxPdpInit = 'true';

      // Remember the configured Add to cart wording before any variant
      // switch overwrites it with "Sold out".
      var label = root.querySelector('[data-lux-pdp-submit] [data-label]');
      if (label && !label.getAttribute('data-add-label')) {
        label.setAttribute('data-add-label', label.textContent.trim());
      }

      initOptions(root);
      initGallery(root);
      initAccordion(root);
      initSizeGuide(root);
      initZoom(root);
      initShare(root);
      initKeyboard(root);

      // First pass only flags which option values are still buyable; the
      // price and stock line already came from Liquid.
      updateVariant(root, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
